import React, { useState, useCallback, useEffect, lazy } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getHistoricalStatus } from 'redux/DashboardConfig/DashboardConfig.action';
import { historicalDataEnabledChannels, getNickNameValue } from 'utilities/utilities_exports';
import { message } from 'antd';
import { forEach as _forEach, isEmpty as _isEmpty } from 'lodash-es';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
const GraasHistoricalDataNotification = lazy(() =>
  import(/* webpackChunkName: 'GraasHistoricalDataNotification' */ 'components/Atoms/GraasHistoricalDataNotification')
);

const HistrocalDataStatus = () => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [filteredResponse, setFilteredResponse] = useState([]);
  const dispatch = useDispatch();
  const historicalStatusList = useSelector(state => state?.DashboardConfig?.historicalStatusConfigs) || [];
  const nickNamesObject = useSelector(state => state.Account?.stores?.nicknames);
  const { t } = useTranslation();

  const onGetOptions = useCallback(async nickNamesObject => {
    try {
      if (!_isEmpty(nickNamesObject)) {
        const nickNameIDList = nickNamesObject
          .map(nickNameObject => nickNameObject?.id)
          .filter(id => id && historicalDataEnabledChannels.includes(id.split('-')[0]));
        if (!_isEmpty(nickNameIDList)) {
          dispatch(getHistoricalStatus(nickNameIDList));
        }
      }
    } catch (error) {
      message.error(t('GRAAS_FAIL_TO_GET_HISTORICAL_JOB_STATUS_DATA_GRAAS'));
    }
  }, []);

  useEffect(() => {
    try {
      if (!_isEmpty(historicalStatusList?.data)) {
        var filteredArray = [];
        _forEach(historicalStatusList?.data, data => {
          data['nickNameValue'] = !_isEmpty(nickNamesObject)
            ? data?.nickNameID.split('-')[0] + '-' + getNickNameValue(nickNamesObject, data?.nickNameID)
            : data?.nickNameID;
          if (
            ['COMPLETED', 'FAILED'].includes(data?.status) &&
            data?.timeLastUpdated > moment().subtract(1, 'days').unix()
          ) {
            const filteredData = filteredArray.filter(item => item?.nickNameID === data?.nickNameID);
            if (filteredData?.length !== 0) {
              if (data?.timeLastUpdated > filteredData[0]?.timeLastUpdated) {
                filteredArray = filteredArray?.filter(item => item?.nickNameID !== data?.nickNameID) || [];
                filteredArray?.push(data);
              }
            } else if (filteredData?.length === 0) {
              filteredArray?.push(data);
            }
          } else if (
            ['PROCESSING'].includes(data?.status) &&
            data?.timeLastUpdated > moment().subtract(2, 'days').unix()
          ) {
            const filteredData = filteredArray.filter(item => item?.nickNameID === data?.nickNameID);
            if (filteredData?.length !== 0) {
              if (data?.timeLastUpdated > filteredData[0]?.timeLastUpdated) {
                filteredArray = filteredArray?.filter(item => item?.nickNameID !== data?.nickNameID) || [];
                filteredArray?.push(data);
              }
            } else if (filteredData?.length === 0) {
              filteredArray?.push(data);
            }
          }
        });
        setFilteredResponse(filteredArray);
      }
    } catch (error) {
      message.error(t('GRAAS_FAIL_TO_GET_HISTORICAL_JOB_STATUS_DATA_GRAAS'));
    }
  }, [historicalStatusList]);

  useEffect(() => {
    if (isButtonClicked) {
      onGetOptions(nickNamesObject);
    }
  }, [isButtonClicked]);

  useEffect(() => {
    onGetOptions(nickNamesObject);
  }, [nickNamesObject]);

  const onButtonClick = e => {
    setIsButtonClicked(!isButtonClicked);
  };

  if (_isEmpty(filteredResponse)) return <></>;

  return (
    <>
      <GraasHistoricalDataNotification
        notificationData={filteredResponse}
        onButtonClick={onButtonClick}
        localization={{
          status_processing: t('GRAAS_HISTORICAL_DATA_IN_PROGRESS_STATUS_GRAAS'),
          status_failed: t('GRAAS_HISTORICAL_DATA_FAILED_STATUS_GRAAS'),
          status_completed: t('GRAAS_HISTORICAL_DATA_COMPLETED_STATUS_GRAAS'),
          importedDataFrom: t('GRAAS_HISTORICAL_DATA_IMPORT_FROM_GRAAS'),
          importingDataFrom: t('GRAAS_HISTORICAL_DATA_IMPORTING_FROM_GRAAS'),
          historicalImportTitle: t('GRAAS_HISTORICAL_DATA_DOWNLOAD_GRAAS')
        }}
      />
    </>
  );
};

export { HistrocalDataStatus };
